import { ITheme } from "@view/constants/theme/theme";
import { ThemeContext } from "@view/root/ThemeProvider/ThemeProvider";
import { useContext } from "react";

/**
 *
 */
export const useTheme = (): {
  theme: ITheme;
  setTheme?: (theme: ITheme) => void;
} => {
  const theme = useContext(ThemeContext);
  if (theme === null) {
    throw new Error("Store cannot be null, please add a context provider");
  }
  return theme;
};
